import { useContext } from "react";

import { LazyRenderingContext } from "./LazyRendering.Provider";

export const useLazyRenderingState = () => useContext(LazyRenderingContext);
